import { render, staticRenderFns } from "./CommonMedicalAdvice.vue?vue&type=template&id=51c4e320&scoped=true"
import script from "./CommonMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./CommonMedicalAdvice.vue?vue&type=script&lang=js"
import style0 from "./CommonMedicalAdvice.vue?vue&type=style&index=0&id=51c4e320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4e320",
  null
  
)

export default component.exports